import { MexAvisoUne } from '../../assets/legal';

const legalLinks = [
  {
    text: 'Costos y comisiones de operar con Fingo',
    href: null,
    isDownload: false,
    redirect: '/help/costs-and-comissions',
  },
  {
    text: 'Términos y condiciones',
    href: null,
    isDownload: false,
    redirect: '/terms',
  },
  {
    text: 'Aviso de privacidad',
    href: null,
    isDownload: false,
    redirect: 'help/notice-of-privacy',
  },
  {
    text: 'Aviso UNE',
    href: MexAvisoUne,
    isDownload: true,
    redirect: null,
  },
];

export default legalLinks;
